import type { DateRange } from '.';
import type { DateRangePickerValue } from './date-range-picker';
import { getPresetDateRange } from './get-preset-date-range';

export const getDateRangeFromValue = (
  value: DateRangePickerValue,
): DateRange => {
  if (value.type === 'dateRange') {
    return value.dateRange;
  }
  return getPresetDateRange(value.presetName);
};
